import { server } from './config'
import client from './client'

export default {
  findPlace(data = {}, config = {}) {
    return client.get(`${server}/checkin/api/findPlace?query=${data}`)
  }
}
